var map = {
	"./IMG_6957.jpg": 113,
	"./IMG_7162.jpg": 161,
	"./IMG_7322.jpg": 162,
	"./IMG_8763.jpg": 163,
	"./IMG_8773.jpg": 114,
	"./IMG_8804.jpg": 164,
	"./IMG_8809.jpg": 112,
	"./IMG_8853.jpg": 165,
	"./IMG_8893.jpg": 166,
	"./IMG_8919.jpg": 115
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;


//////////////////
// WEBPACK FOOTER
// ./src/vertical nonrecursive \.(png|jpe?g|svg)$
// module id = 160
// module chunks = 0